<template>
  <VueFinalModal
    class="s-modal"
    :modal-id="modalId"
    :click-to-close="!isCloseProhibited"
    :esc-to-close="!isCloseProhibited"
    data-cy="modal"
    @closed="onClose"
  >
    <template #default>
      <div class="vfm-modal" :style="{ maxWidth: typeof maxContentWidth === 'string' ? maxContentWidth : `${maxContentWidth}px` }">
        <button
          v-if="!isCloseProhibited"
          type="button"
          data-cy="modal-close"
          class="vfm-modal__btn-close"
          @click="reject('closed-by-cross')"
        >
          <svg width="24" height="24" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
            <g>
              <path
                stroke="currentColor"
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="1.5"
                d="m18 6.356-12 12m12 0-12-12"
              />
            </g>
            <defs>
              <clipPath id="a">
                <path fill="#fff" d="M0 0h24v24H0z" />
              </clipPath>
            </defs>
          </svg>
        </button>
        <slot name="default" v-bind="{ payload, resolve, reject }"></slot>
      </div>
    </template>
  </VueFinalModal>
</template>

<script setup lang="ts">
import {toRefs, ref, PropType} from 'vue'
import { VueFinalModal } from 'vue-final-modal'
import {useModal} from './useModal'
const modal = useModal()
const {open, close} = modal
const props = defineProps({
  modalId: {
    type: String,
    default: ''
  },
  maxContentWidth: {
    type: [Number, String] as PropType<number | string>,
    default: 640
  },
  isCloseProhibited: {
    type: Boolean,
    default: false
  },
})
const { modalId, maxContentWidth, isCloseProhibited } = toRefs(props)
const payload = ref<unknown>(null)
let promiseResolve: (value: unknown) => void = () => {}
let promiseReject: (reason?: any) => void = () => {}
const init = (data: unknown): Promise<unknown> => {
  return new Promise((resolve:(value: unknown) => void, reject:(reason?: any) => void) => {
    payload.value = data
    promiseResolve = resolve
    promiseReject = reject
    open(modalId.value)
  })
}
const resolve = (payload: unknown) => {
  promiseResolve(payload)
  close(modalId.value)
}
const reject = (payload: unknown) => {
  promiseReject(payload)
  close(modalId.value)
}
const onClose = () => {
  promiseReject('closed')
}
defineExpose({
  init
})
</script>

<style src="vue-final-modal/style.css"></style>

<style lang="scss">
@mixin button-reset() {
  padding: 0;
  border: none;
  font: inherit;
  color: inherit;
  background-color: transparent;
  cursor: pointer;
  outline: none;
}
.s-modal {
  display: flex;
  align-items: center;
  justify-content: center;
}

.vfm-modal {
  background: #ffffff;
  width: 100%;
  max-width: 640px;
  padding: 24px;
  position: relative;
  border-radius: 8px;
  &__btn-close {
    @include button-reset;
    position: absolute;
    right: 24px;
    top: 24px;
    color: var(--color-icon-secondary);
    &:hover {
      color: var(--color-icon-tertiary);
    }
  }
}
</style>
